const FLOATING_VISIBLE_CLASS = "intro-tabs-floating--visible";

const createFloatingTabs = (sourceTabs) => {
  const floating = document.createElement("div");
  floating.className = "intro-tabs-floating";

  const inner = document.createElement("div");
  inner.className = "intro-tabs-floating__inner";

  const tabsClone = sourceTabs.cloneNode(true);
  inner.appendChild(tabsClone);
  floating.appendChild(inner);

  return floating;
};

const bindFloatingTabs = (tabsSection) => {
  const sourceTabs = tabsSection.querySelector(".intro-tabs");
  const footer = document.querySelector(".footer");

  if (!sourceTabs) {
    return;
  }

  const floatingTabs = createFloatingTabs(sourceTabs);
  document.body.appendChild(floatingTabs);

  let frameId = null;

  const updateVisibility = () => {
    frameId = null;

    const tabsRect = tabsSection.getBoundingClientRect();
    const floatingRect = floatingTabs.getBoundingClientRect();
    const footerRect = footer?.getBoundingClientRect();

    const passedSourceTabs = tabsRect.bottom <= 0;
    const overlapsFooter = footerRect
      ? footerRect.top <= window.innerHeight - floatingRect.height - 16
      : false;
    const shouldShow = passedSourceTabs && !overlapsFooter;

    floatingTabs.classList.toggle(FLOATING_VISIBLE_CLASS, shouldShow);
  };

  const requestVisibilityUpdate = () => {
    if (frameId !== null) {
      return;
    }

    frameId = window.requestAnimationFrame(updateVisibility);
  };

  requestVisibilityUpdate();

  window.addEventListener("scroll", requestVisibilityUpdate, { passive: true });
  window.addEventListener("resize", requestVisibilityUpdate);
};

export const initFloatingIntroTabs = (documentReference = document) => {
  const tabsSections = documentReference.querySelectorAll(".section-intro__tabs");

  tabsSections.forEach(bindFloatingTabs);
};
